import React from "react";
import { useTranslation } from "react-i18next";
import "./styles/Services.css";
import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function SoftwareDevelopment() {
    const { t } = useTranslation();

    return (
        <div className="service-page">
            <SEO
                title={t('software.seo_title')}
                description={t('software.seo_desc')}
                keywords={t('software.seo_keywords')}
                url="/software-development"
                schemaType="service"
            />
            <TitleFragment title={t('software.page_title')} />

            <div className="service-container">
                <p className="service-intro-text" style={{ textAlign: 'center', fontSize: '1.4rem', fontWeight: '500', marginTop: '2rem', marginBottom: '1rem' }}>
                    {t('software.subtitle')}
                </p>

                <section className="service-section">
                    <p className="service-intro-text">
                        {t('software.intro')}
                    </p>
                </section>

                <section className="service-section">
                    <h2>{t('software.what_we_do')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h3>{t('software.app_dev_title')}</h3>
                            <p>{t('software.app_dev_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('software.ui_eng_title')}</h3>
                            <p>{t('software.ui_eng_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('software.charts_title')}</h3>
                            <p>{t('software.charts_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('software.3d_title')}</h3>
                            <p>{t('software.3d_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('software.code_title')}</h3>
                            <p>{t('software.code_desc')}</p>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('software.industries_title')}</h2>
                    <div className="service-feature-list">
                        <div className="service-feature-item">{t('software.ind_auto')}</div>
                        <div className="service-feature-item">{t('software.ind_industrial')}</div>
                        <div className="service-feature-item">{t('software.ind_health')}</div>
                        <div className="service-feature-item">{t('software.ind_finance')}</div>
                        <div className="service-feature-item">{t('software.ind_smart')}</div>
                        <div className="service-feature-item">{t('software.ind_aero')}</div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('software.why_title')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h4>{t('software.why_expertise_title')}</h4>
                            <p>{t('software.why_expertise_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('software.why_end_title')}</h4>
                            <p>{t('software.why_end_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('software.why_cross_title')}</h4>
                            <p>{t('software.why_cross_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('software.why_track_title')}</h4>
                            <p>{t('software.why_track_desc')}</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default SoftwareDevelopment;
